import { useAuthStore } from '@akin-home/auth/react';
import { useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import { LoginScreenView } from './LoginScreenView';
import { WelcomeScreen } from './WelcomeScreen';
import { ChatItemContent } from './components/ChatItemContent';
import { EnterNewPasswordForm } from './components/EnterNewPasswordForm';
import { ForgotPasswordEnterResetCodeForm } from './components/ForgotPasswordEnterNewPassword';
import { ForgotPasswordEnterUsernameForm } from './components/ForgotPasswordEnterUsernameForm';
import { LoginForm } from './components/LoginForm';
import { INTENT_LABELS, LOGIN_SCREEN_DATA } from './data';
import { useLoginScreenState } from './login_screen_state';

const { title, first_time_login_title } = LOGIN_SCREEN_DATA;

export function PreAuthScreen() {
  const has_passed_welcome = useLoginScreenState(
    (state) => state.has_passed_welcome
  );

  const closeWelcome = useLoginScreenState((state) => state.closeWelcome);

  if (!has_passed_welcome) {
    return <WelcomeScreen continue={closeWelcome} />;
  }

  return <LoginScreen />;
}

export function LoginScreen() {
  const state = useLoginScreenState();
  const [chat_item, sendLabel] = useLoginScreenState(
    (state) => [state.chat_item, state.sendLabel],
    shallow
  );
  const authenticating = useAuthStore((state) => state.authenticating);

  useEffect(() => {
    sendLabel(INTENT_LABELS.LOGIN_SCREEN_SHOWN);
  }, [sendLabel]);

  /** Reset the idle timer whenever the chat_item changes */
  useEffect(() => {
    const timer_id = setTimeout(() => {
      sendLabel(INTENT_LABELS.USER_IS_IDLE);
    }, 1000 * 60 * 3);

    return () => {
      clearTimeout(timer_id);
    };
  }, [chat_item, sendLabel]);

  let body = null;
  let showBackButton = false;
  switch (state.stage) {
    case 'login':
      body = (
        <LoginForm
          loading={authenticating}
          username={state.username}
          password={state.password}
          password_mode={state.password_mode}
          setPasswordMode={state.setPasswordMode}
          setUsername={state.setUsername}
          setPassword={state.setPassword}
          onPressLogin={state.signIn}
          onPressForgotPassword={state.goToForgotPassword}
        />
      );
      break;
    case 'forgot_password_enter_username':
      body = (
        <ForgotPasswordEnterUsernameForm
          username={state.username}
          onPressSendCode={state.sendResetCode}
        />
      );
      showBackButton = true;
      break;
    case 'forgot_password_enter_code':
      body = (
        <ForgotPasswordEnterResetCodeForm
          loading={state.resetting_password}
          onPressSubmit={state.submitForgotPassword}
        />
      );
      showBackButton = true;
      break;
    case 'enter_new_password':
      body = (
        <EnterNewPasswordForm
          loading={state.resetting_password}
          onSubmit={state.submitNewPassword}
        />
      );
  }

  return (
    <LoginScreenView
      body={body}
      title={state.has_logged_in_before ? title : first_time_login_title}
      onPressBack={showBackButton ? state.goBackToLogin : undefined}
      onLongPressAvatar={state.showWelcome}
      chat_item={
        chat_item ? (
          <ChatItemContent
            chat_item={chat_item}
            onPressOption={state.selectOption}
          />
        ) : null
      }
    />
  );
}
